import React from 'react'
import styled, { injectGlobal } from 'styled-components'
import typography from '../../../vars/typography'
import breakpoints from '../../../vars/breakpoints'
import colors from '../../../vars/colors'

export const H1 = styled.h1`
    font-size: 62px;
    font-family: 'OneDotCd', sans-serif;
    font-weight: bold;
    color: ${props => props.color === 'blue' ? colors['peacock-blue'] : colors['lipstick']};
    letter-spacing: 2px;
    text-transform: uppercase;
    @media (max-width: ${breakpoints['bp-tablet']}) {
        font-size: 45px;
        letter-spacing: normal;
    }
    @media (max-width: ${breakpoints['bp-mobile']}) {
        font-size: 36px;
        letter-spacing: normal;
    }
`

export const H2 = styled.h2`
    font-size: 50px;
    font-family: 'OneDotCd', sans-serif;
    font-weight: bold;
    color: ${props => props.color === 'blue' ? colors['peacock-blue'] : colors['lipstick']};
    letter-spacing: 3px;
    margin-bottom: 20px;
    text-transform: uppercase;
    @media (max-width: ${breakpoints['bp-tablet']}) {
        font-size: 44px;
        letter-spacing: normal;
    }
    @media (max-width: ${breakpoints['bp-mobile']}) {
        font-size: 36px;
        letter-spacing: normal;
    }
`

export const BODY = styled.div`
    font-family: 'OneDot', sans-serif;
`



// WEBPACK FOOTER //
// ./src/components/global/typography/typography.js